import { useCallback, useMemo, useState } from 'react';
import { GridState } from '@mui/x-data-grid';

export const useTableStateWatcher = (disabled?: boolean) => {
  const [state, setState] = useState({
    isSorted: false,
    isFiltered: false,
    isPaginated: false,
    isSelected: false,
  });

  const updateState = useCallback(
    (state: GridState) => {
      if (disabled) {
        return;
      }

      const isSorted = !!state.sorting.sortModel.length;
      const isFiltered = !!state.filter.filterModel.items.length;
      const isPaginated = !!state.pagination.paginationModel.page;
      const isSelected = !!state.rowSelection.length;

      setState({
        isSorted,
        isFiltered,
        isPaginated,
        isSelected,
      });
    },
    [disabled],
  );

  const isTableStateChanged = useMemo(() => {
    return state.isSorted || state.isFiltered || state.isPaginated || state.isSelected;
  }, [state]);

  return {
    updateState,
    isTableStateChanged,
  };
};
